import Vue from "vue";
import Vuex from "vuex";
import userModule from "./store/user";
import generalModule from "./store/general";
import menuModule from "./store/menu";
import calcsettings from "./store/calcsettings";
import calcTariffsettings from "./store/calcTariffsettings";
import protocolsInfo from "./store/protocolsInfo";
import Winners from "./store/winners.js";
import usersWinners from "./store/usersWinners.js";
import agentMainOrgInfo from "./store/agentMainOrgInfo";
import agentFirmBankRekv from "./store/agentFirmBankRekv";
import UserManagement from "./store/userManagement";
import MyCalculations from "./store/myCalculations";
import Podriads from "./store/podriads";
import Support from "./store/support";
import organization from "./store/organization";
import calc from "./store/calc";
import payments from "./store/payments";
import rating from "./store/rating";
import ratingLikes from "./store/ratingLikes";
import geo from "./store/geo";
import excell from "./store/excell";
import registerBG from "./store/registerBG";
import ignoreWinners from "./store/IgnoreWinners";
import docs from "./store/myDocuments";
import calcFilter from "./store/calcFilter";
import unsubcribes from "./store/unsubscribe";
import statistics from "./store/statistics";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    userModule,
    generalModule,
    menuModule,
    calcsettings,
    calcTariffsettings,
    Winners,
    agentMainOrgInfo,
    agentFirmBankRekv,
    UserManagement,
    MyCalculations,
    Podriads,
    Support,
    organization,
    usersWinners,
    protocolsInfo,
    calc,
    payments,
    rating,
    ratingLikes,
    geo,
    excell,
    registerBG,
    ignoreWinners,
    docs,
    calcFilter,
    unsubcribes,
    statistics,
  },
});
